/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// actions
import { surveyActions } from '../../../application/actions/survey';
// configs
import routes from '../../../application/config/routes';
// components
import UsabilityAndSatisfaction from '../../components/organisms/surveys/UsabilityAndSatisfaction';
import BecauseMember from '../../components/organisms/surveys/BecauseMember';
import Needs from '../../components/organisms/surveys/Needs';
import Abandonment from '../../components/organisms/surveys/Abandonment';
import AlreadyMember from '../../components/organisms/surveys/AlreadyMember';
import sendAnalitycs from '../../../domain/utils/utilitarios-frontend-coopeuch/Analytics';
import dataLayerObject from '../../../domain/utils/dataLayerObject';
// data
import usabilityAndSatisfactionData from './dumb/usabilityAndSatisfaction.json';
import becauseMemberData from './dumb/becauseMember.json';
import abandonmentData from './dumb/abandonment.json';
import needsData from './dumb/needs.json';
import alreadyMemberData from './dumb/alreadyMember.json';
import edgeCases from '../../localData/edgeCases';

// const
const urlsToRedirect = {
  13: 'https://webprivado.coopeuch.cl/#/',
  14: 'https://webprivado.coopeuch.cl/#/',
  15: 'https://puntoscoopeuch.cl/?active=pro#section-promos',
  16: 'https://www.coopeuch.cl/personas/credito-consumo.html',
  17: 'https://www.coopeuch.cl/personas/',
  18: 'https://www.coopeuch.cl/personas/centro-de-ayuda',
};

/* istanbul ignore next */
const getStateSuffix = (type) => {
  return type === 'becauseMember' ? '-becauseMember' : '';
};
/* istanbul ignore next */
const handleSuccessfulResponse = (type, responses, setCurrentEdgeCase, setState) => {
  setCurrentEdgeCase(edgeCases.successful);
  setState(`sent${getStateSuffix(type)}`);
  
  if (type === 'alreadyMember') {
    window.location = urlsToRedirect[responses[0].idOption];
  }
};
/* istanbul ignore next */
const handleErrorResponse = (type, setCurrentEdgeCase, setState) => {
  setCurrentEdgeCase(edgeCases.errorSurveyAbandonment);
  setState(`error${getStateSuffix(type)}`);
};
/* istanbul ignore next */
const handleBecauseMemberState = (type, registerResponses, changeForeignState) => {
  if (type !== 'becauseMember') return;
  
  const hasResponse = registerResponses.success || registerResponses.error;
  if (!hasResponse) return;
  
  /* istanbul ignore next */
  const newState = registerResponses.success ? 'sent-becauseMember' : 'error-becauseMember';
  changeForeignState(newState);
};
/* istanbul ignore next */
const Survey = (props) => {
  const {
    type,
    disabled,
    changeForeignState,
    foreignState,
    validationRequireFields,
    onReceiveSurveyData,
    onCloseModal,
  } = props;
  
  const [surveyData, setSurveyData] = useState({ questions: [] });
  const [state, setState] = useState('');
  const [responses, setResponses] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [optionsSelected, setOptionsSelected] = useState([]);
  const [canContinue, setCanContinue] = useState(false);
  const [currentEdgeCase, setCurrentEdgeCase] = useState({
    title: '',
  });

  const appRoutes = routes();
  const dispatch = useDispatch();
  const registerResponses = useSelector((store) => store.entities.survey.registerResponses);
  const isLoadingRegisterSurvey = useSelector((store) => store.ui.loaders.isLoadingRegisterSurvey);
  /* istanbul ignore next */
  useEffect(() => {
    setState('initial');
    switch (type) {
      case 'becauseMember':
        setSurveyData(becauseMemberData);
        break;
      case 'needs':
        setSurveyData(needsData);
        break;
      case 'usabilityAndSatisfaction':
        setSurveyData(usabilityAndSatisfactionData);
        break;
      case 'abandonment':
        setSurveyData(abandonmentData);
        break;
      case 'alreadyMember':
        setSurveyData(alreadyMemberData);
        break;
      default:
        break;
    }
  }, []);

  /* istanbul ignore next */
  useEffect(() => {
    const isLastQuestion = currentQuestion === surveyData.questions.length;
    const hasResponses = responses.length > 0;
    
    if (!isLastQuestion || !hasResponses) {
      return;
    }

    /* istanbul ignore next */
    if (registerResponses.success) {
      handleSuccessfulResponse(type, responses, setCurrentEdgeCase, setState);
    } else if (registerResponses.error) {
      handleErrorResponse(type, setCurrentEdgeCase, setState);
    }

    /* istanbul ignore next */
    handleBecauseMemberState(type, registerResponses, changeForeignState);
    
    /* istanbul ignore next */
    setCurrentQuestion(1);
  }, [registerResponses]);

  useEffect(() => {
    if (optionsSelected.length) {
      let isValid = true;
      /* istanbul ignore next */
      optionsSelected.forEach((element) => {
        const totalOptionSelected = surveyData.questions[currentQuestion - 1].alternatives.filter(
          (el) => el.idOption === element.idOption
        )[0];
        if (totalOptionSelected.comment)
          if (totalOptionSelected.comment.required)
            if (element.comment.length < 2) {
              isValid = false;
              // eslint-disable-next-line no-useless-return
              return;
            }
      });
      /* istanbul ignore next */
      setCanContinue(isValid);
    }
    if (onReceiveSurveyData)
      /* istanbul ignore next */
      onReceiveSurveyData({ idSurvey: surveyData.idSurvey, responses: optionsSelected });
  }, [optionsSelected]);

  useEffect(() => {
    if (responses.length > 0) {
      // COMMENT: obtenemos la descripcion o valor de la opcion elegida para el caso donde no es multiple
      let descriptionOptionSelected = '';
      let comment = '';
      /* istanbul ignore next */
      if (surveyData.questions[currentQuestion - 1].optionsMultiple === false) {
        descriptionOptionSelected = surveyData.questions[currentQuestion - 1].alternatives.filter(
          (el) => el.idOption === optionsSelected[0].idOption
        )[0].description;
        comment = optionsSelected[0].comment;
      }
      /* istanbul ignore next */
      if (currentQuestion === surveyData.questions.length) {
        // COMMENT: Si estamos en la ulitma pregunta, enviamos las respuestas al servicio
        const payloadRegisterResponses = {
          idSurvey: surveyData.idSurvey,
          responses,
        };
        /* istanbul ignore next */
        dispatch(surveyActions.registerResponses(payloadRegisterResponses));
        /* istanbul ignore next */
        if (type === 'becauseMember') {
          const idOptionsSelected = optionsSelected.map((el) => el.idOption);
          const reasons = surveyData.questions[currentQuestion - 1].alternatives
            .filter((el) => idOptionsSelected.includes(el.idOption))
            .map((el) => el.description);
          sendAnalitycs(dataLayerObject.SURVEY_BECAUSE_MEMBER_SENDING, [
            {
              key: 'eve-lab',
              param: 'motivo',
              value: reasons.toString(),
            },
          ]);
          // COMMENT: guardamos en el storage, los nombres de los productos seleccionados
          sessionStorage.setItem('products', reasons.join('%'));
        } else if (type === 'usabilityAndSatisfaction') {
          sendAnalitycs(dataLayerObject.SURVEY_USABILITY_SATISFACTION_2, [
            {
              key: 'eve-lab',
              param: 'puntuacion-comentario',
              value: `${descriptionOptionSelected} - ${comment}`,
            },
          ]);
        } else if (type === 'abandonment') {
          sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_SENDING, [
            {
              key: 'eve-cat',
              param: 'ubicacion',
              value: window.location.pathname,
            },
            {
              key: 'eve-acc',
              param: 'paso',
              value: window.location.pathname,
            },
            {
              key: 'eve-lab',
              param: 'opcion-comentario',
              value: `${descriptionOptionSelected} - ${comment}`,
            },
          ]);
        }
        // TODO: esto es temporal, sacar cuando el servicio survey sea llamado
        handleTemporalSendingResponses('type');
      } else if (type === 'alreadyMember') {
        sendAnalitycs(dataLayerObject.ADDITIONALS_CONTINUE);
      } else {
        if (type === 'usabilityAndSatisfaction') {
          sendAnalitycs(dataLayerObject.SURVEY_USABILITY_SATISFACTION_1, [
            {
              key: 'eve-lab',
              param: 'puntuacion-comentario',
              value: `${descriptionOptionSelected} - ${comment}`,
            },
          ]);
        }
        setCurrentQuestion((prev) => prev + 1);
      }
      /* istanbul ignore next */
      setOptionsSelected([]);
    }
  }, [responses]);
  
  /* istanbul ignore next */
  const handleTemporalSendingResponses = (surveyName) => {
    setCurrentEdgeCase(edgeCases.successful);
    setState(`sent${surveyName === 'becauseMember' ? '-becauseMember' : ''}`);
    setCurrentQuestion(1);
  }
  
  /* istanbul ignore next */
  const handleSelectOptions = ({ idOption, selected }) => {
    let optionsSelectedTemp = [];
    if (surveyData.questions[currentQuestion - 1].optionsMultiple) {
      optionsSelectedTemp =
        selected === true
          ? [...optionsSelected, { idOption, comment: '' }]
          : optionsSelected.filter((el) => el.idOption !== idOption);
    } else optionsSelectedTemp = [{ idOption, comment: '' }];

    setOptionsSelected(optionsSelectedTemp);
  };
  
  /* istanbul ignore next */
  const handleChangeComment = ({ idOption, comment }) => {
    const optionsSelectedTemp = optionsSelected.map((el) => {
      if (el.idOption === idOption) {
        return {
          ...el,
          comment,
        };
      }
      return el;
    });
    setOptionsSelected(optionsSelectedTemp);
  };
  
  /* istanbul ignore next */
  const handleClickContinue = () => {
    setResponses([...responses, ...optionsSelected]);
    // COMMENT: despues de hacer click para ir a la pregunta 2, llamammos el load de la siguiente
    setCanContinue(false);
  };

  const handleClickOptionMember = ({ idOption /* , description */ }) => {
    /* istanbul ignore next */
    const clicketText = alreadyMemberData.questions[0].alternatives.filter((el) => el.idOption === idOption)[0].description || '';
    /* istanbul ignore next */
    sendAnalitycs(dataLayerObject.BORDE_ALREADY_MEMBER_ELECTION, [
      {
        key: 'eve-lab',
        param: 'eleccion',
        value: clicketText,
      },
    ]);
    /* istanbul ignore next */
    setOptionsSelected([{ idOption, /* description, */ comment: '' }]);
    /* istanbul ignore next */
    setResponses([{ idOption, comment: '' }]);
  };

  const handleRetrySendResponses = () => {
    /* istanbul ignore next */
    setState('initial');
    /* istanbul ignore next */
    if (type === 'becauseMemeber') changeForeignState('initial');
  };
  
  /* istanbul ignore next */
  const handleExitFlow = (surveyType) => {
    if (surveyType === 'usabilityAndSatisfaction') {
      sendAnalitycs(dataLayerObject.SURVEY_USABILITY_SATISFACTION_EXIT);
    } else if (surveyType === 'abandonment') {
        sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_EXIT, [
          {
            key: 'page',
            param: 'paso',
            value: window.location.pathname,
          },
        ]);
    }
    window.location = appRoutes.landing.path;
  };

  const handleResumeContratation = () => {
    /* istanbul ignore next */
    onCloseModal();
    /* istanbul ignore next */
    sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_RETURN, [
      {
        key: 'eve-acc',
        param: 'paso',
        value: window.location.pathname,
      },
    ]);
  };

  return (
    surveyData.questions.length && (
      <>
        {type === 'usabilityAndSatisfaction' && (
          <UsabilityAndSatisfaction
            data-testid="usability-and-satisfaction"
            state={state}
            currentEdgeCase={currentEdgeCase}
            optionSelected={optionsSelected[0] || {}}
            currentQuestion={currentQuestion}
            questions={surveyData.questions}
            canContinue={canContinue}
            onClickContinue={handleClickContinue}
            onSelectOption={handleSelectOptions}
            onChangeComment={handleChangeComment}
            onExitFlow={handleExitFlow}
            onRetrySendResponses={handleRetrySendResponses}
          />
        )}
        {type === 'abandonment' && (
          <Abandonment
            data-testid="abandonment-survey"
            state={state}
            currentEdgeCase={currentEdgeCase}
            optionSelected={optionsSelected[0] || {}}
            question={surveyData.questions[0]}
            canContinue={canContinue}
            onSendResponses={handleClickContinue}
            onSelectOption={handleSelectOptions}
            onChangeComment={handleChangeComment}
            onResumeContratation={handleResumeContratation}
            onExitFlow={handleExitFlow}
            onRetrySendResponses={handleRetrySendResponses}
          />
        )}
        {type === 'becauseMember' && (
          <BecauseMember
            data-testid="because-member-survey"
            state={foreignState}
            optionsSelected={optionsSelected}
            question={surveyData.questions[0]}
            disabled={disabled}
            onSelectOption={handleSelectOptions}
            onChangeComment={handleChangeComment}
            onSendResponses={handleClickContinue}
            onRetrySendResponses={handleRetrySendResponses}
          />
        )}
        {type === 'alreadyMember' && (
          <AlreadyMember
            data-testid="already-member-survey"
            isLoadingRegisterSurvey={isLoadingRegisterSurvey}
            question={surveyData.questions[0]}
            onSelectOption={handleClickOptionMember}
          />
        )}
        {type === 'needs' && (
          <Needs
            data-testid="needs-survey"
            validationRequireFields={validationRequireFields}
            optionsSelected={optionsSelected}
            question={surveyData.questions[0]}
            onSelectOption={handleSelectOptions}
          />
        )}
      </>
    )
  );
};

export default Survey;